import React from 'react'
import { WorkspaceSsoConfigFragment } from '@sketch/gql-types'

import { useFlag } from 'containers/flags'
import {
  NeedHelpSection,
  WorkspaceSettingsEnableSsoPanel,
  WorkspaceSettingsScimPanel,
  WorkspaceSettingsSsoSetupPanel,
} from 'modules/workspace/components'

interface WorkspaceSettingsSsoProps {
  customerId: string
  workspaceId: string
  ssoShortName?: string
  isSsoEnabled: boolean
  isScimEnabled: boolean
  config?: WorkspaceSsoConfigFragment
}

export const WorkspaceSettingsSso: React.FC<WorkspaceSettingsSsoProps> = ({
  customerId,
  workspaceId,
  ssoShortName,
  isSsoEnabled,
  isScimEnabled,
  config,
}) => {
  const isScimFlagEnabled = useFlag('scim-access')

  if (ssoShortName) {
    return (
      <>
        <WorkspaceSettingsSsoSetupPanel
          customerId={customerId}
          workspaceShortName={ssoShortName}
          isSsoEnabled={isSsoEnabled}
          config={config!}
        />
        {isScimFlagEnabled && (
          <WorkspaceSettingsScimPanel
            workspaceId={workspaceId}
            isSsoEnabled={isSsoEnabled}
            isScimEnabled={isScimEnabled}
          />
        )}
        <NeedHelpSection />
      </>
    )
  }

  return <WorkspaceSettingsEnableSsoPanel customerId={customerId} />
}
